<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<mat-toolbar
	*ngIf="(attachedFilesService.viewState$ | async) !== attachmentViewState.SingleSelectMode"
	class="toolbar-styles"
	[ngClass]="(hideTrashIcon$ | async) ? 'trash-hidden' : 'trash-shown'"
>
	<button mat-icon-button (click)="changeSelectionViewMode()">
		<mat-icon>arrow_back</mat-icon>
	</button>
	<div>
		<ng-container *ngIf="(attachedFilesService.viewState$ | async) === attachmentViewState.MultiSelectMode">
			<ng-container [ngSwitch]="attachedFilesService.numFileSelection$ | async">
				<span *ngSwitchCase="0">
					{{ appStrings.TAP_TO_SELECT_ITEMS }}
				</span>
				<span *ngSwitchDefault>
					{{ attachedFilesService.numFileSelection$ | async }} {{ appStrings.SELECTED }}
				</span>
			</ng-container>
		</ng-container>
	</div>
	<div>
		<!-- div to take up the space in grid layout -->
		<button
			mat-icon-button
			class="select-button"
			(click)="attachedFilesService.launchFullViewClicked()"
			*ngIf="(attachedFilesService.viewState$ | async) === attachmentViewState.FileCarouselView"
		>
			<i class="material-icons">
				<span>launch</span>
			</i>
		</button>
	</div>
	<button
		mat-icon-button
		class="select-button"
		(click)="onDownloadClicked()"
		[disabled]="
			(attachedFilesService.viewState$ | async) !== attachmentViewState.FileCarouselView &&
			!(attachedFilesService.numFileSelection$ | async)
		"
	>
		<i class="material-icons"><span>download</span></i>
	</button>
	<button
		mat-icon-button
		class="select-button"
		(click)="deleteFilesClicked()"
		*ngIf="!(hideTrashIcon$ | async)"
	>
		<i class="material-icons"><span>delete</span></i>
	</button>
</mat-toolbar>

<mat-toolbar
	*ngIf="(attachedFilesService.viewState$ | async) === attachmentViewState.SingleSelectMode"
	class="display-flex-toolbar"
>
	<span
		>{{ (attachedFilesService.file$ | async).length }}
		{{
			(attachedFilesService.file$ | async).length === 1 ? appStrings.ATTACHMENT : appStrings.ATTACHMENTS
		}}</span
	>
	<button
		mat-icon-button
		class="select-button"
		(click)="changeSelectionViewMode()"
		*ngIf="(attachedFilesService.file$ | async).length >= 1"
	>
		<span>Select</span>
	</button>
</mat-toolbar>
